export default "__VITE_ASSET__Cyfrg9SL__"